module.exports = __webpack_public_path__ + "img/tg-super.d9defe97.png";